function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useId, useState } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var statusText = value => String(value || 'Awaiting update').toLowerCase().replace(/_/g, ' ').replace(/^./, c => c.toUpperCase());
export var distanceText = meters => Number.isFinite(meters) && meters >= 0 ? meters < 1000 ? "".concat(Math.round(meters), " m") : "".concat((meters / 1000).toFixed(1), " km") : 'Unavailable';
export var durationText = seconds => Number.isFinite(seconds) && seconds >= 0 ? seconds < 60 ? 'Less than 1 min' : "".concat(Math.ceil(seconds / 60), " min") : 'Unavailable';
export var arrivalText = (computedAt, seconds) => {
  var at = new Date(computedAt).getTime();
  return Number.isFinite(at) && Number.isFinite(seconds) ? new Date(at + seconds * 1000).toLocaleTimeString([], {
    hour: '2-digit',
    minute: '2-digit'
  }) : 'Unavailable';
};
export function Hint(_ref) {
  var label = _ref.label,
    children = _ref.children;
  var id = useId();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    show = _useState2[0],
    setShow = _useState2[1];
  return /*#__PURE__*/_jsx(OverlayTrigger, {
    show: show,
    onToggle: setShow,
    placement: "top",
    flip: true,
    popperConfig: {
      modifiers: [{
        name: "offset",
        options: {
          offset: [0, 12]
        }
      }, {
        name: "preventOverflow",
        options: {
          padding: 12
        }
      }]
    },
    overlay: /*#__PURE__*/_jsx(Tooltip, {
      id: id,
      children: children
    }),
    children: /*#__PURE__*/_jsx("button", {
      type: "button",
      className: "btn btn-link p-0 ms-1",
      style: {
        fontSize: 16,
        minWidth: 44,
        minHeight: 44
      },
      onClick: () => setShow(true),
      onKeyDown: e => {
        if (e.key === "Escape") {
          e.stopPropagation();
          setShow(false);
        }
      },
      "aria-label": "About ".concat(label),
      children: "\u24D8"
    })
  });
}
export default function TrackingDetails(_ref2) {
  var _route$stops, _node$pickup, _node$drop, _node$location;
  var node = _ref2.node,
    route = _ref2.route;
  var ride = node.kind === 'ride';
  var steps = ride ? ['Assigned', 'On the way', 'Picked up', 'In transit', 'Completed'] : ['Assigned', 'Picked up', 'In transit', 'Delivered'];
  var index = ride ? {
    SCHEDULED: 0,
    ASSIGNED: 0,
    STARTED: 1,
    PICKED_UP: 2,
    IN_TRANSIT: 3,
    COMPLETED: 4
  }[node.status] : {
    PENDING: 0,
    PICKED_UP: 1,
    IN_TRANSIT: 2,
    DELIVERED: 3
  }[node.status];
  var ok = (route === null || route === void 0 ? void 0 : route.status) === 'OK';
  var next = ok ? (_route$stops = route.stops) === null || _route$stops === void 0 ? void 0 : _route$stops[0] : null;
  var metrics = [['To next stop', distanceText(next === null || next === void 0 ? void 0 : next.remainingMeters), 'Road distance from the reported GPS position to the next displayed stop, including preceding stops where applicable.'], ['Travel time', durationText(next === null || next === void 0 ? void 0 : next.etaSeconds), 'Google traffic estimate at the calculation time. Waiting, loading and boarding time are excluded.'], ['Estimated arrival', ok ? arrivalText(route.computedAt, next === null || next === void 0 ? void 0 : next.etaSeconds) : 'Unavailable', 'Calculated from the route timestamp plus travel time, displayed in your device timezone.'], [route !== null && route !== void 0 && route.target ? 'To your destination' : 'Remaining run', ok ? distanceText(route.distanceMeters) : 'Unavailable', 'Total remaining road distance for the route visible to your role. It is not distance already travelled.']];
  return /*#__PURE__*/_jsxs("section", {
    "aria-label": "Trip details",
    className: "border rounded p-3 my-3 bg-light",
    style: {
      overflowWrap: "anywhere"
    },
    children: [/*#__PURE__*/_jsxs("div", {
      className: "d-flex flex-wrap justify-content-between gap-2",
      children: [/*#__PURE__*/_jsx("strong", {
        children: node.driverName || (ride ? 'Assigned driver' : 'Assigned delivery agent')
      }), /*#__PURE__*/_jsxs("span", {
        children: ["Trip #", node.id.slice(-6), node.scheduledTime ? " \xB7 Scheduled ".concat(node.scheduledTime) : '']
      })]
    }), /*#__PURE__*/_jsx("ol", {
      "aria-label": "Delivery progress",
      className: "d-flex flex-wrap gap-3 list-unstyled my-3",
      children: steps.map((step, i) => /*#__PURE__*/_jsxs("li", {
        "aria-current": i === index ? 'step' : undefined,
        className: index != null && i <= index ? 'text-success fw-semibold' : 'text-secondary',
        children: [index != null && i < index ? '✓' : "".concat(i + 1, "."), " ", step, i === index ? ' (current)' : '']
      }, step))
    }), index == null && /*#__PURE__*/_jsxs("p", {
      role: "status",
      children: ["Current status: ", statusText(node.status), ". Contact the transport desk for the next action."]
    }), /*#__PURE__*/_jsx("div", {
      className: "row g-2",
      children: metrics.map(_ref3 => {
        var _ref4 = _slicedToArray(_ref3, 3),
          label = _ref4[0],
          value = _ref4[1],
          help = _ref4[2];
        return /*#__PURE__*/_jsx("div", {
          className: "col-6 col-lg-3",
          children: /*#__PURE__*/_jsxs("div", {
            className: "bg-white border rounded p-2 h-100",
            children: [/*#__PURE__*/_jsxs("div", {
              className: "small text-secondary",
              children: [label, /*#__PURE__*/_jsx(Hint, {
                label: label,
                children: help
              })]
            }), /*#__PURE__*/_jsx("strong", {
              children: value
            })]
          })
        }, label);
      })
    }), /*#__PURE__*/_jsxs("p", {
      className: "small mt-3 mb-1",
      children: [/*#__PURE__*/_jsx("strong", {
        children: "Pickup:"
      }), " ", ((_node$pickup = node.pickup) === null || _node$pickup === void 0 ? void 0 : _node$pickup.label) || 'Not provided']
    }), /*#__PURE__*/_jsxs("p", {
      className: "small mb-1",
      children: [/*#__PURE__*/_jsx("strong", {
        children: "Drop:"
      }), " ", ((_node$drop = node.drop) === null || _node$drop === void 0 ? void 0 : _node$drop.label) || 'Not provided']
    }), /*#__PURE__*/_jsxs("span", {
      className: "small",
      children: ["GPS accuracy: ", distanceText((_node$location = node.location) === null || _node$location === void 0 ? void 0 : _node$location.accuracyMeters), /*#__PURE__*/_jsx(Hint, {
        label: "GPS accuracy",
        children: "Reported device accuracy radius. A large radius means the vehicle may be anywhere within that area. Missing accuracy is not assumed to be zero."
      })]
    })]
  });
}